<template>
  <div class="square" @click="$emit('on-click')" v-tooltip.bottom="tooltip">
    {{ !icon ? name : "" }}
    <div v-if="icon" style="width: 2.5rem" v-html="icon"></div>
  </div>
</template>

<script>
export default {
  name: "Block",
  props: {
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
      default: "",
    },
    tooltip: {
      type: String,
      required: true,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.square {
  background: #343233;
  border-radius: 9px;
  width: 5rem;
  height: 5rem;
  margin: 0.3rem 0.5rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  font-family: "Rubik";
  font-weight: 600;
  transition: all 0.2s ease;
  color: white;
  &:hover {
    background: lighten(#343233, 2%);
    box-shadow: 0px 0px 6px 5px lighten(#343233, 2%);
  }
}
</style>
